import { T } from '@transifex/react';

import { cn } from '~/lib/utils';

export function FormGroup(props: React.PropsWithChildren<{ className?: string }>) {
  return (
    <fieldset className={cn('flex min-w-0 flex-1 flex-col gap-1', props.className)}>
      {props.children}
    </fieldset>
  );
}

export function ResponsiveRow(props: React.PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={cn(
        `
          flex flex-col gap-6
          md:flex-row
        `,
        props.className
      )}
    >
      {props.children}
    </div>
  );
}

export function OptionalTag() {
  return (
    <span className="rounded-xs bg-background-100 px-sm py-0 text-body-small">
      <T _str="Optional" />
    </span>
  );
}

export function HelpText({ children }: { children: React.ReactNode }) {
  return <p className="text-body-small text-muted-foreground">{children}</p>;
}
